import { createSelector } from 'reselect';

export const dataSelector = ({ data }, props) => ({ data, props });

export const indicatorSelector = createSelector(
  dataSelector,
  ({ data: { indicator } }) => indicator
);

export const geographySelector = createSelector(
  dataSelector,
  ({ data: { geography } }) => geography
);

export const allGeographiesSelector = createSelector(
  dataSelector,
  ({ data: { allGeographies } }) => allGeographies
);

export const allIndicatorsSelector = createSelector(
  dataSelector,
  ({ data: { allIndicators } }) => allIndicators
);

export const allGeographiesUsdata = createSelector(
  allGeographiesSelector,
  ({ usdata }) => usdata
);

export const allGeographiesInternational = createSelector(
  allGeographiesSelector,
  ({ international }) => international
);

export const allIndicatorsUsdata = createSelector(
  allIndicatorsSelector,
  ({ usdata }) => usdata
);

export const allIndicatorsInternational = createSelector(
  allIndicatorsSelector,
  ({ international }) => international
);

export default {
  dataSelector,
  indicatorSelector,
  geographySelector,
  allGeographiesSelector,
  allIndicatorsSelector,
  allGeographiesUsdata,
  allGeographiesInternational,
  allIndicatorsUsdata,
  allIndicatorsInternational,
};



// WEBPACK FOOTER //
// ./app/selectors/basic.js